import { v4 as uuidv4 } from 'uuid';

export function ProductHighlightText(props = {}, childrenComponents = []) {
	return {
		componentName: 'ProductHighlightText',
		componentId: uuidv4(),
		props: Object.assign({
			message: '{highlightName}',
			blockClass: 'hl-text',
			link: '/collection/{highlightName}',
		}),
		childrenComponents,
	};
}
